import { createContext } from 'react';

export const DisclosureDeliveryContext = createContext(null);
